/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';
import { eligibilityPostRequestSchema } from './eligibilityPostRequestSchema.ts';
import { eligibilityPostResponseSchema } from './eligibilityPostResponseSchema.ts';

/**
 * @description 200 response
 */
export const postEligibility200Schema = z.lazy(() => eligibilityPostResponseSchema);

/**
 * @description 505 response
 */
export const postEligibility505Schema = z.any();

export const postEligibilityMutationRequestSchema = z.lazy(() => eligibilityPostRequestSchema);

export const postEligibilityMutationResponseSchema = z.lazy(() => postEligibility200Schema);
